import React, { useState } from 'react';
import { HistoryIcon, BotIcon, CpuIcon, PuzzleIcon, BookOpenIcon, WrenchIcon, SearchIcon } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
import { useAgentStore } from '../stores/agentStore';
import { useModelStore } from '../stores/modelStore';
import { PageContainer, PageHeader } from '../components/common/page';
import { Card, Badge, Input, Select } from '../components/common/ui';
import { formatDateTime } from '../utils/format';
interface HistoryRow {
  id: string;
  agentName: string;
  modelName: string;
  skills: string[];
  knowledgeBases: string[];
  toolCalls: number;
  skillCalls: number;
  retrievalCalls: number;
  preview: string;
  at: string;
}
const MOCK_HISTORY: HistoryRow[] = [{
  id: 'h1',
  agentName: '运维助手',
  modelName: 'Claude Sonnet 4',
  skills: ['Linux 运维 Skill'],
  knowledgeBases: ['产品文档库'],
  toolCalls: 3,
  skillCalls: 1,
  retrievalCalls: 2,
  preview: '检查 web-01 服务器磁盘占用并清理日志',
  at: '2026-06-05T08:30:00Z'
}, {
  id: 'h2',
  agentName: '代码开发助手',
  modelName: 'GPT-4o',
  skills: ['代码审查 Skill'],
  knowledgeBases: [],
  toolCalls: 1,
  skillCalls: 0,
  retrievalCalls: 0,
  preview: '审查 PR #482 的并发安全问题',
  at: '2026-06-04T19:20:00Z'
}, {
  id: 'h3',
  agentName: '运维助手',
  modelName: 'Claude Sonnet 4',
  skills: ['Nginx 日志分析 Skill'],
  knowledgeBases: ['产品文档库'],
  toolCalls: 2,
  skillCalls: 1,
  retrievalCalls: 1,
  preview: '分析昨晚的 502 错误高峰原因',
  at: '2026-06-04T14:05:00Z'
}];
export function HistoryPage() {
  useScreenInit();
  const agents = useAgentStore(s => s.agents);
  const [query, setQuery] = useState('');
  const [agentFilter, setAgentFilter] = useState('all');
  const rows = MOCK_HISTORY.filter(r => {
    if (agentFilter !== 'all' && r.agentName !== agentFilter) return false;
    if (query && !r.preview.toLowerCase().includes(query.toLowerCase())) return false;
    return true;
  });
  return <PageContainer data-id="element-509">
      <PageHeader title="历史记录" description="按 Agent、模型、Skill、知识库、时间范围筛选会话历史" data-id="element-510" />

      <div className="mb-4 flex flex-col gap-2 sm:flex-row" data-id="element-511">
        <div className="relative flex-1" data-id="element-512">
          <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" data-id="element-513" />
          <Input value={query} onChange={e => setQuery(e.target.value)} placeholder="搜索会话内容" className="pl-9" data-id="element-514" />
        </div>
        <Select value={agentFilter} onChange={e => setAgentFilter(e.target.value)} className="sm:w-48" data-id="element-515">
          <option value="all" data-id="element-516">全部 Agent</option>
          {agents.map(a => <option key={a.agentId} value={a.name} data-id="element-517">
              {a.name}
            </option>)}
        </Select>
      </div>

      <div className="space-y-3" data-id="element-518">
        {rows.map(r => <Card key={r.id} className="p-4" data-id="element-519">
            <div className="flex flex-wrap items-center gap-2" data-id="element-520">
              <Badge tone="indigo" data-id="element-521">
                <BotIcon className="h-3 w-3" data-id="element-522" /> {r.agentName}
              </Badge>
              <Badge tone="blue" data-id="element-523">
                <CpuIcon className="h-3 w-3" data-id="element-524" /> {r.modelName}
              </Badge>
              {r.skills.map(s => <Badge key={s} tone="purple" data-id="element-525">
                  <PuzzleIcon className="h-3 w-3" data-id="element-526" /> {s}
                </Badge>)}
              {r.knowledgeBases.map(kb => <Badge key={kb} tone="green" data-id="element-527">
                  <BookOpenIcon className="h-3 w-3" data-id="element-528" /> {kb}
                </Badge>)}
              <span className="ml-auto text-xs text-slate-500" data-id="element-529">
                {formatDateTime(r.at)}
              </span>
            </div>
            <p className="mt-2 text-sm text-slate-300" data-id="element-530">{r.preview}</p>
            <div className="mt-2 flex gap-4 text-xs text-slate-500" data-id="element-531">
              <span className="inline-flex items-center gap-1" data-id="element-532">
                <WrenchIcon className="h-3 w-3" data-id="element-533" /> {r.toolCalls} 次工具调用
              </span>
              <span className="inline-flex items-center gap-1" data-id="element-534">
                <PuzzleIcon className="h-3 w-3" data-id="element-535" /> {r.skillCalls} 次 Skill 调用
              </span>
              <span className="inline-flex items-center gap-1" data-id="element-536">
                <BookOpenIcon className="h-3 w-3" data-id="element-537" /> {r.retrievalCalls}{' '}
                次知识库检索
              </span>
            </div>
          </Card>)}
      </div>
    </PageContainer>;
}